/* eslint-disable react/react-in-jsx-scope */
import React, { useCallback, useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Styles from '../styles.module.css'

export default function MultiSliderComponent({
  min,
  max,
  onChange,
  bgRangeColor = '#F70A23',
  bgTrackColor = '#000',
  valueColor = '#10B0F0'
}) {
  const [minVal, setMinVal] = useState(min)
  const [maxVal, setMaxVal] = useState(max)

  const minValRef = useRef(null)
  const maxValRef = useRef(null)
  const range = useRef(null)

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  )

  // Set width of the range to decrease from the left side
  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal)
      const maxPercent = getPercent(+maxValRef.current.value) // Precede with '+' to convert the value from type string to type number

      if (range.current) {
        range.current.style.left = `${minPercent}%`
        range.current.style.width = `${maxPercent - minPercent}%`
      }
    }
  }, [minVal, getPercent])

  // Set width of the range to decrease from the right side
  useEffect(() => {
    if (minValRef.current) {
      const minPercent = getPercent(+minValRef.current.value)
      const maxPercent = getPercent(maxVal)

      if (range.current) {
        range.current.style.width = `${maxPercent - minPercent}%`
      }
    }
  }, [maxVal, getPercent])

  // Get min and max values when their state changes
  useEffect(() => {
    onChange({ min: minVal, max: maxVal })
  }, [minVal, maxVal, onChange])

  return (
    <div className={`${Styles.container}`}>
      <input
        type='range'
        min={min}
        max={max}
        value={minVal}
        ref={minValRef}
        onChange={(event) => {
          const value = Math.min(+event.target.value, maxVal - 1)
          setMinVal(value)
          event.target.value = value
        }}
        className={
          minVal > max - 100
            ? `${Styles.thumb} ${Styles.thumbzindex3}`
            : `${Styles.thumb} ${Styles.thumbzindex3}`
        }
      />
      <input
        type='range'
        min={min}
        max={max}
        value={maxVal}
        ref={maxValRef}
        onChange={(event) => {
          const value = Math.max(+event.target.value, minVal + 1)
          setMaxVal(value)
          event.target.value = value
        }}
        className={`${Styles.thumb} ${Styles.thumbzindex4}`}
      />

      <div className={`${Styles.slider}`}>
        <div
          className={`${Styles.slidertrack}`}
          style={{ backgroundColor: bgTrackColor }}
        >
          <div
            ref={range}
            className={`${Styles.sliderrange}`}
            style={{ backgroundColor: bgRangeColor }}
          />
          <div
            className={`${Styles.sliderleftvalue}`}
            style={{ color: valueColor }}
          >
            {minVal}
          </div>
          <div
            className={`${Styles.sliderrightvalue}`}
            style={{ color: valueColor }}
          >
            {maxVal}
          </div>
        </div>
      </div>
    </div>
  )
}

// Set the type of each prop
MultiSliderComponent.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}
